// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-user-profile_modal__JLdRF","closeIcon":"modal-user-profile_closeIcon__2xhIM"};